import type { FirebaseApp } from 'firebase/app';
import { getPerformance, trace, type FirebasePerformance } from 'firebase/performance';
import { useFirebaseEmulators, isProductionEnv } from '../../config/env';

let performance: FirebasePerformance | null = null;

export function initPerformance(app: FirebaseApp) {
  if (useFirebaseEmulators() || !isProductionEnv()) {
    return { enabled: false };
  }

  try {
    performance = getPerformance(app);
    return { enabled: true };
  } catch (err) {
    console.warn('[Performance] init skipped:', err);
    return { enabled: false };
  }
}

export function startTrace(name: string) {
  if (!performance) return { stop: () => {} };
  const t = trace(performance, name);
  t.start();
  return { stop: () => t.stop() };
}
